import React from 'react';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import css from './PasswordType.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../../common/utils/styles';

const PasswordType = ({ setShowPass, showPass, compStyle }) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    return (
        <div
            style={{
                ...stylers.formInputPasswordEye,
                fill: 'var(--greyExtraDarkColor)'
            }}
            className={classnames(css.formControlIconWrap, classes.formInputPasswordEye)}
            onClick={() => setShowPass((pre) => !pre)}
        >
            {!showPass
                ? svgSprite('eye-slash', {
                      width: '28px',
                      height: '28px',
                      style: { pointerEvents: 'none' },
                      fill: 'rgba(117, 81, 51, 1)',
                      filter: 'drop-shadow(0px 4px 4px rgba(117, 81, 51, 0.35))'
                  })
                : svgSprite('eye', {
                      width: '28px',
                      height: '28px',
                      style: { pointerEvents: 'none' },
                      fill: 'rgba(117, 81, 51, 1)',
                      filter: 'drop-shadow(0px 4px 4px rgba(117, 81, 51, 0.35))'
                  })}
        </div>
    );
};
export default PasswordType;
